export interface CoverPhoto {
  url: string;
}

export interface BlogPost {
  id: string;
  title: string;
  description: string;
  readTime: number;
  slug: string;
  content: {
    // GraphCMS raw AST; accepted by RichText `content` prop
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    raw: any;
    // Optional; only present if the API returns embed references
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    references?: any[];
  };
  author: {
    id: string;
  };
  coverPhoto: CoverPhoto;
  datePublished: string;
  tags: string[];
}

export interface PostsQueryResult {
  posts: BlogPost[];
}

export const GRAPHCMS_ENDPOINT =
  'https://api-ap-south-1.graphcms.com/v2/cl4mpujwl7y9a01xv80jxacfs/master';

/**
 * Keep the query minimal — matching the schema that already worked.
 * Do not request content.references here (breaks on this project endpoint).
 */
export const BLOG_POSTS_QUERY = `
  {
    posts {
      id
      title
      description
      readTime
      slug
      content {
        raw
      }
      author {
        id
      }
      coverPhoto {
        url
      }
      datePublished
      tags
    }
  }
`;
